import styled from 'styled-components'
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
export const NavbarContainer = styled.div`
    background-color: rgba(0,0,0,0.95);
    min-width: 100vw;
    min-height: 70px;
    padding: 10px 15vw;
    display:flex;
    position: fixed;
    top:0;
    left:0;
    right:0;
    z-index:1;

`
export const Logo = styled.div`
    cursor: pointer;
    display: flex;
    align-items:center;
    justify-content: center;
    max-width:15vw;
    @media(max-width: 1100px){
        min-width: 100%;
    }
`
export const LinkSection = styled.div`
    min-width: 70%;
    margin-left: 5vw;
    display: flex;
    align-items:center;
    justify-content: space-between;
`

export const PrimaryLink = styled.div`
    display: flex;
    margin: 0 50px;
    font-family: 'Oxygen Mono', monospace;
    font-weight: 400;
    color: white;
    align-items:center;
    justify-content: space-between;
    a { 
        font-size: 18px;
        font-weight: 400;
        margin: 0 15px;
        padding: 0 15px;
        flex-wrap: nowrap;
        letter-spacing:1px;
        :hover {
            background-color: rgb(56, 56, 56);
            color: azure;
          }
    }
    @media(max-width: 1100px){
        display: none;
    }
`

export const Contact = styled(PrimaryLink)`

`

export const CustomMenu = styled(MenuIcon)`
    @media screen and (min-width: 0px) and (max-width: 1070px) {
        cursor: pointer;
        color: white;
        font-size: 20px;
    }
    @media screen and (min-width: 401px) and (max-width: 1024px) {
        display: hidden;
    }

`
export const BurgerMenu = styled.div`
    position: fixed;
    top:0;
    bottom:0;
    right:0;
    background-color: rgba(249,249,249, 0.98);
    width: 80vw;
    z-index: 100;
    list-style: none;
    padding: 20px;
    display: flex;
    flex-direction: column;
    text-align: start;
    transform: ${props => props.show ? 'translateX(0)' : 'translateX(100%)' } ;
    transition: transform 0.3s ease-in;
    li{ 
        padding: 8px 8px;
        a{  
            font-size:28px;
            font-weight: 450;
        }
    }
    
`

export const CustomClose = styled(CloseIcon)`
    cursor: pointer;
`
export const CloseWrapper = styled.div`
    display:flex;
    justify-content: flex-end;
`